import { App } from 'vue';

// Own config
import '@/core/config/breakpointConfig';

// errorhandling as first
import errorHandling from '@/core/errorHandling';


// Trigger for prerender flag
import '@/core/prerender';

// App-related
import '@/core/app';

// 3rd party
import icons from '@/core/config/svg-icons.plugin';

// Various areas
import formConfig from '@/core/form';
import responsive from '@/core/responsive';
import translation from '@/core/translation';
import dom from '@/core/dom';
import filters from '@/core/filters';
import syncBodylockGap from '@/core/scroll/syncBodylockGap.directive';
import intersection from '@/core/intersection';
import '@/core/ui-components';
import AccessibilityPlugin from '@/core/accessibility';

// All other core component registrations
import componentRegistration from './coreComponentRegistrations';

export default async function configCore(app: App): Promise<void> {
    errorHandling(app);
    componentRegistration(app);
    translation(app);
    formConfig(app);
    responsive(app);
    dom(app);
    filters(app);
    icons(app);
    syncBodylockGap(app);
    intersection(app);
    AccessibilityPlugin(app);
}
